import { render, staticRenderFns } from "./FormSocial.vue?vue&type=template&id=748bcafe&scoped=true"
import script from "./FormSocial.vue?vue&type=script&lang=js"
export * from "./FormSocial.vue?vue&type=script&lang=js"
import style0 from "./FormSocial.vue?vue&type=style&index=0&id=748bcafe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748bcafe",
  null
  
)

export default component.exports